import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject} from 'rxjs';
import {NavItem} from '../../../models/staff/navitem';
import {NavItemService} from '../../../service/staff/service-navitem';
import {NavCode} from '../../../models/staff/navcode';
import {NavCodeService} from '../../../service/staff/service-navcode';

@Component({
  templateUrl: './assignmenu.component.html'

})export class AssignMenuPermissionComponent implements OnInit {
  public language = language;
  public code: string = '';
  public checked: boolean = false;
  public checkedAll: boolean = false;
  public isEdit: boolean = false;
  public isSuDung: boolean = true;
  public onClose: Subject<boolean>;
  public dataCheck: Object[]=[];
  public navCodeList: NavCode[] = [];
  public navItemList: NavItem[] = [];
  constructor( public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public _bsModalRef: BsModalRef,
               public navItemService: NavItemService,
               public navCodeService: NavCodeService
  ) {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }
  edit(code: string) {
    this.code = code.trim();
    this.navItemService.getAll().subscribe(x => {this.navItemList = x;
      this.dataCheck = [];
      this.checkedAll = false;
      this.navCodeService.findAllByCode(this.code).subscribe(y => {
        this.navCodeList = y;
        for (let i = 0; i < this.navCodeList.length; i++)
          this.dataCheck.push(this.navCodeList[i].navID);
        for (let i = 0; i < this.navItemList.length; i++) {
          this.navItemList[i].active = this.navCodeList.findIndex(k => k.navID === this.navItemList[i].id) !== -1 ? true : false;
        }
      });
    });
  }
  public checkedItem(event)
  {
    if(event.target.checked === true && this.dataCheck.indexOf(Number(event.target.value)) == -1)
      this.dataCheck.push(event.target.value);
    else
      this.dataCheck.splice(this.dataCheck.indexOf(Number(event.target.value)),1);
  }
  public checkAll(event)
  {
    this.dataCheck = [];
    this.checked = event.target.checked;
    for(let i = 0; i < this.navItemList.length;i++) {
      this.navItemList[i].active = event.target.checked;
      if(event.target.checked === true)
        this.dataCheck.push(this.navItemList[i].id);
    }
  }
  public summitActive()
  {    this.navCodeService.addMulti(this.code, this.dataCheck.join()).subscribe(
    {    next: (data) => {
        this.toastr.success(language.message_permission_success, language.message);
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });

  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }
  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
